import styled, { css } from 'styled-components';
import { calculateZoom } from '../../../../../../store/form/utils';
import ScrollableContent from '../../../../../ScrollableContent';
import { PreviewProps } from '../../Style';
// import { BannerPreviewContent } from "../../Style";

interface BannerContentPreviewFrame
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  width: number;
  height: number;
  zoom?: number;
  backgroundImageUrl: string;
  form: SingleBannerForm;
}

// Extraia o conteúdo CSS do Styled Component
const getCSSFromStyledComponent = (component) => {
  // A propriedade 'styledComponentId' é gerada automaticamente pelo Styled Components
  const styledComponentId = component.styledComponentId;

  // Encontre o estilo correspondente ao ID
  const styleTag = document.querySelector(
    `style[data-styled='${styledComponentId}']`,
  );

  // Obtenha o conteúdo CSS
  const cssContent = styleTag ? styleTag.textContent : '';

  return cssContent;
};

export const BannerPreviewContent = styled.div<PreviewProps>`
  ${({ $height, $zoom, $backgroundImage }) => css`
    position: relative;
    min-height: ${$height}px;
    max-height: ${$height}px;
    ${$backgroundImage
      ? `
     background-image: url("${$backgroundImage}");
     background-size: 100% 100%;
     background-repeat: no-repeat;
     `
      : ``}
  `}
`;

function BannerContentPreviewFrame({
  width,
  height,
  zoom,
  form,
  backgroundImageUrl,
  ...props
}: BannerContentPreviewFrame) {
  const previewProps: any = {
    $width: width,
    $height: height,
    $zoom: zoom,
    $backgroundImage: backgroundImageUrl,
  };

  return (
    <ScrollableContent
      width={width}
      height={height}
      scale={Math.max(calculateZoom(0.1, 3, zoom ?? 0.5), 1)}
    >
      <div
        style={{
          position: 'relative',
          minHeight: `${height}px`,
          maxHeight: `${height}px`,
          ...(() =>
            backgroundImageUrl
              ? {
                  backgroundImage: `url("${backgroundImageUrl}")`,
                  backgroundSize: '100% 100%',
                  backgroundRepeat: 'no-repeat',
                }
              : {})(),
          transform: `scale(${zoom ? calculateZoom(0.1, 3, zoom) : 1})`,
          width: '-webkit-fill-available',
          overflow: 'hidden',
        }}
      ></div>
    </ScrollableContent>
  );
}

export default BannerContentPreviewFrame;
